export default "__VITE_ASSET__4uQ5FuJa__"